import { Button, ButtonSize, ButtonStyle, buttonStyleOptions } from "../components/button"
import { Icons, iconOptionsWithPictograms } from "../../types"

import React from "react"
import { TypographyAlign } from "../components/typography"
import classNames from "classnames"
import { types } from "react-bricks/frontend"
import RedesignButton, { RedesignButtonSize, RedesignButtonStyle } from "../redesign/Button"

export interface ButtonBrickProps {
    href: string
    title: string
    style: ButtonStyle | RedesignButtonStyle
    size?: ButtonSize | RedesignButtonSize
    showIcon: boolean
    icon?: Icons
    index?: number
    target?: string
    align?: TypographyAlign
    fullWidth?: boolean
    identifier?: string
    disabled?: boolean
    redesign?: boolean
}

const ButtonBrick: types.Brick<ButtonBrickProps> = ({
    href,
    target,
    title,
    style,
    size,
    index,
    icon,
    showIcon,
    fullWidth,
    identifier,
    disabled = false,
    redesign = false,
}) => {
    return (
        <div
            key={index}
            className={classNames("w-full", {
                "sm:inline-block sm:w-auto": !fullWidth,
            })}
        >
            {redesign ? (
                <RedesignButton
                    href={href}
                    withOnClick={() => {
                        if (!identifier) return

                        window.exponea?.track("calltoaction", {
                            action: "clicked",
                            title: title,
                            identifier: identifier,
                        })
                    }}
                    target={target}
                    title={title}
                    style={style as RedesignButtonStyle}
                    size={size as RedesignButtonSize}
                    icon={showIcon ? icon : undefined}
                    fullWidth={fullWidth}
                    disabled={disabled}
                />
            ) : (
                <Button
                    href={href}
                    withOnClick={() => {
                        if (!identifier) return

                        window.exponea?.track("calltoaction", {
                            action: "clicked",
                            title: title,
                            identifier: identifier,
                        })
                    }}
                    target={target}
                    title={title}
                    style={style as ButtonStyle}
                    size={size as ButtonSize}
                    icon={showIcon ? icon : undefined}
                    fullWidth={fullWidth}
                    disabled={disabled}
                />
            )}
        </div>
    )
}

ButtonBrick.schema = {
    name: "Button",
    label: "Button",
    hideFromAddMenu: true,
    sideEditProps: [
        {
            name: "href",
            label: "Button Link",
            type: types.SideEditPropType.Text,
        },
        {
            name: "target",
            label: "Target",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: [
                    {
                        value: "_self",
                        label: "Self",
                    },
                    {
                        value: "_blank",
                        label: "Blank",
                    },
                ],
                display: types.OptionsDisplay.Select,
            },
        },
        {
            name: "title",
            label: "Title",
            type: types.SideEditPropType.Text,
        },
        {
            name: "showIcon",
            label: "Show Icon",
            type: types.SideEditPropType.Boolean,
        },
        {
            name: "icon",
            label: "Icon",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: iconOptionsWithPictograms,
                display: types.OptionsDisplay.Select,
            },
            show: props => props.showIcon,
        },
        {
            name: "style",
            label: "Style",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: buttonStyleOptions,
                display: types.OptionsDisplay.Select,
            },
        },
        {
            name: "disabled",
            label: "Disabled",
            type: types.SideEditPropType.Boolean,
        },
        {
            groupName: "Tracking",
            props: [
                {
                    name: "identifier",
                    label: "Identifier Bloomreach",
                    type: types.SideEditPropType.Text,
                },
            ],
        },
    ],
    getDefaultProps: (): ButtonBrickProps => ({
        href: process.env.SITE_URL,
        title: "LaVita",
        icon: Icons.cart,
        showIcon: true,
        style: ButtonStyle.Primary,
        disabled: false,
        redesign: false,
    }),
}

export default ButtonBrick
